import React from 'react';
import { AttentionAndSystem } from '../components/AttentionAndSystem';
import { BrandPlatform } from '../components/BrandPlatform';
import { Footer } from '../components/Footer';
import { GoneFishing } from '../components/GoneFishing';
import { Hero } from '../components/Hero';
import { Manifesto } from '../components/Manifesto';
import { Navbar } from '../components/Navbar';
import { PricingSection } from '../components/PricingSection';
export function HomePage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-[#f7f5ef] text-[#11110f]" data-id="element-880">
      <Navbar data-id="element-881" />
      <main data-id="element-882">
        <Hero data-id="element-883" />
        <AttentionAndSystem data-id="element-884" />
        <GoneFishing data-id="element-885" />
        <BrandPlatform data-id="element-886" />
        <PricingSection data-id="element-887" />
        <Manifesto data-id="element-888" />
      </main>
      <Footer data-id="element-889" />
    </div>;
}